import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch, connect } from 'react-redux';

import Intro from './Intro';
import Get from './Get';
import Keep from './Keep';
import Grow from './Grow';
import Referrals from './Referrals';
import Summary from './Summary';
import Section from '../../components/Section';
import * as AppRoute from '../../utils/appRoutes';
import { prepareComponents } from '../../utils/helpers';
import { select } from '../../rematcher/store';

const components = [Intro, Get, Keep, Grow, Referrals, Summary];

function GetKeepGrow({
  locales,
  locales: {
    getKeepGrow: { name, menu, sectionName },
  },
  progress,
}) {
  const {
    getKeepGrow: { fetchGetKeepGrows },
    bmc: { fetchCurrentBmc, updateBmc },
    customerSegment: { fetchCustomerSegments },
  } = useDispatch();

  const {
    bmc: { current: currentBmc },
  } = useSelector((state) => state);

  const { bmcId } = useParams();
  const preparedComponents = prepareComponents(
    components,
    bmcId,
    menu,
    AppRoute.getKeepGrow,
  );

  const getData = useCallback(() => {
    fetchCurrentBmc(bmcId);
    fetchGetKeepGrows(bmcId);
    fetchCustomerSegments(bmcId);
  }, [bmcId]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentBmc.id)
      updateBmc({
        id: currentBmc.id,
        name: 'get_keep_grow_progress',
        value: parseInt(progress),
      });
  }, [progress]);

  return (
    <Section
      components={preparedComponents}
      sectionName={sectionName}
      sectionLocaleName={name}
      menuItems={menu}
      progress={progress}
      locales={locales}
      finalDestination={AppRoute.bmc(bmcId)}
      onComponentChange={getData}
    />
  );
}

const mapState = select((models) => ({
  progress: models.progress.gkgProgress,
}));

export default connect(mapState, null)(GetKeepGrow);
